import type { CatalogFilter } from '~/types/catalog'

export function useRangeFilter(props: {
  filter: CatalogFilter
  selected: string
}) {
  const range = ref([0, 0])

  // Input fields
  const inputMin = shallowRef(0)
  const inputMax = shallowRef(0)

  const hasRange = computed(() => {
    const { min, max } = props.filter

    return (min === 0 && max === 0) || min === max
  })

  const rangeMin = computed({
    get: () => range.value[0],
    set: (value: number) => {
      const min = Math.max(props.filter.min, Math.min(value, props.filter.max))

      inputMin.value = min
      // range.value[0] = min
      range.value = [
        min,
        range.value[1]
      ]

      if (min > rangeMax.value) {
        rangeMax.value = min
      }
    }
  })

  const rangeMax = computed({
    get: () => range.value[1],
    set: (value: number) => {
      const max = Math.min(props.filter.max, Math.max(value, props.filter.min))

      inputMax.value = max

      range.value = [
        range.value[0],
        max
      ]

      if (rangeMin.value > max) {
        rangeMin.value = max
      }
    }
  })

  const created = () => {
    if (props.selected) {
      const [from, to] = props.selected.split('-').map((value) => parseFloat(value))

      rangeMin.value = from
      rangeMax.value = to
    } else {
      rangeMin.value = props.filter.min
      rangeMax.value = props.filter.max
    }
  }

  created()

  return {
    range,
    hasRange,
    inputMin,
    inputMax,
    rangeMin,
    rangeMax
  }
}
